module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"pageTitle":"Connexion","form":{"labelUsername":"Email","labelPassword":"Mot de passe","submitTitle":"Connexion","errorLoginFailed":"Email ou mot de passe incorrect"}},"en":{"pageTitle":"Sign in","form":{"labelUsername":"Email","labelPassword":"Password","submitTitle":"Sign in","errorLoginFailed":"Incorrect email or password"}}}')
  delete Component.options._Ctor
}
